module.exports = __webpack_public_path__ + "media/images/countrysquared/in-f0c8f3664f43ec4c0bacaec696b28620.svg";